import { getBearerToken, isAdmin, mouseEventStyles, Page, dynamicResourceLinks } from "./util";
import ControlPannel from "./ControlPannel";
import CustomLink from "./CustomLink";
import axios from "axios";
import $ from 'jquery'
import InputPassword from "./InputPassword";

const EditPassword = () => {
	return (
		<Page className="create-user">
			<div className="navpad h50"></div>
			<ControlPannel >
				{
					isAdmin()
						?
						<CustomLink className="users left"
							to={"/users"}
							{...mouseEventStyles(
								{ backgroundColor: "rgba(255, 255, 255, 0.2)" },
								{ backgroundColor: "rgba(255, 255, 255, 0.3)" }
							)}>
							<img src={dynamicResourceLinks("ff09ff").userIcon} alt="" className="icon" />
							<div className="tooltip">
								manage users
							</div>
						</CustomLink>
						:
						<div></div>
				}
				<div></div>
			</ControlPannel>
			<form action="" onSubmit={(e) => {
				e.preventDefault()
				var data = new FormData();
				var count = 0
				var append = (key) => {
					if ($("#" + key).val() !== "") {
						count++
						console.log("append key: " + key + " with value: |" + $("#" + key).val() + "|")
						data.append(key, $("#" + key).val())
					}
				}
				if ($("#cpassword").val() !== "" && $("#password").val() !== "" && $("#currentpassword").val() !== "") {
					if ($("#cpassword").val() !== $("#password").val()) {
						$("#message").removeAttr("style")
						$("#message").text("Passwords do not match!")
						$("#message").attr("style", "color: orangered")
						return
					}
					append('currentpassword');
					append('password');
				}
				// data.append('avatar', 1)
				if (count)
					axios.put("https://api.pcbang.ma/api/users/me", data, {
						headers: {
							Authorization: getBearerToken(),
							'Content-Type': 'multipart/form-data'
						}
					}).then((res) => {
						if (res.status / 100 === 2) {
							$("#message").removeAttr("style")
							$("#message").text("Success!")
							$("#message").attr("style", "color: lime")
						}
					}).catch((err) => {
						console.log({ err })
						$("#message").removeAttr("style")
						$("#message").text(err.response.data.error.message + "!")
						$("#message").attr("style", "color: orangered")
					})
				else {
					$("#message").removeAttr("style")
					$("#message").text("All fields are required!")
					$("#message").attr("style", "color: orangered")
				}
			}}>
				<label htmlFor="">Current Password: </label>
				<InputPassword type="password" name="" id="currentpassword"/>
				<label htmlFor="">New Password: </label>
				<InputPassword type="password" name="" id="password"/>
				<label htmlFor="">Confirm New Password: </label>
				<InputPassword type="password" name="" id="cpassword"/>
				{/* <InputPassword></InputPassword> */}
				<p htmlFor="" id="message" className="flex-as-cr"><wbr></wbr></p>
				<input type="submit" name="submit" value="CHANGE MY PASSWORD" className="submitbutton" />
				<div className="navpad"></div>
			</form>
		</Page>
	);
}
 
export default EditPassword;